module.exports = __webpack_public_path__ + "img/motor_no55.bd12f637.jpg";